<template>
  <div id="admdashboard" class="block">
    <div class="content">
      <ul>       
          <router-link
            v-for="link in links"
            :key="link.url"            
            :to="link.url"
            custom
            v-slot="{href, navigate}"
            active-class="active"

          >
            <li><a :href="href" @click="navigate">{{link.title}}</a></li>
          </router-link>
       
      </ul>
    </div>
  </div>
</template>

<script>
export default {
    data: () => ({
      links: [
        //{title: 'Главная', url: '/adminmain', },
        {title: 'Связать пользователя с ребенком', url: '/users'},
        {title: 'Подтвердить связь пользователя с ребенком', url: '/userrequests'},
        /*{title: 'Пациенты', url: '/patients'},
        {title: 'Врачи', url: '/doctors'},
        {title: 'Записи к врачу', url: '/admappointments'},*/
      ]
    }),
  };
</script>